import { render, staticRenderFns } from "./CongressTableSection.vue?vue&type=template&id=4ccfec68&scoped=true&"
import script from "./CongressTableSection.vue?vue&type=script&lang=js&"
export * from "./CongressTableSection.vue?vue&type=script&lang=js&"
import style0 from "./CongressTableSection.vue?vue&type=style&index=0&id=4ccfec68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ccfec68",
  null
  
)

export default component.exports